import HeaderWrapper from '@components/layout/header/headerWrapper';

import Calendar from './Calendar';

const CalendarWrapper: React.FC<{ selector?: boolean }> = ({ selector }) => {
  const showHeader = !selector;

  return (
    <>
      {/** biome-ignore lint/correctness/useUniqueElementIds: <only occurs once> */}
      <div id="fixed-header" className="fixed-header">
        {showHeader && <HeaderWrapper />}
      </div>

      <Calendar />
    </>
  );
};

export default CalendarWrapper;
